<div class="dashboard--module-header">
    <h2 class="subheading-sm">Recent bills <button class="info-btn focus-element" (click)="onInfoClick()"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2><div class="ic-beware-wrapper" *ngIf="issues && issues.length > 0"><span class="ic-beware">!</span></div>
</div>
<div class="module--main">
    <ng-container *ngIf="latestBill && historyBills">
        <div class="block-num justify-center text-center">
            <span class="lg">{{latestBill.totalAmount | currency:'GBP'}}</span>
            <span class="sm">latest bill value <br>{{latestBill.datePosted | date:'dd/MM/yyyy'}}</span>
        </div>
    </ng-container>
    <ng-container *ngIf="!latestBill">
        <div class="block-num justify-center text-center">
            <span class="sm">No bills history data avaliable</span>
        </div>
    </ng-container>
    <div class="block-detail" *ngIf="historyBills && historyBills.length > 0">
        <table class="std-table stacked-sm">
            <thead>
            <th>Bill No.</th>
            <th>Bill period</th>
            <th>Bill date</th>
            <th>Ex. VAT</th>
            <th>VAT</th>
            <th>Total</th>
            <th></th></thead>
            <tbody>
                <ng-container *ngFor="let historyBillTop of historyBills; let i = index">
                    <tr>
                        <td data-label="Bill No.">
                            {{historyBillTop.invoiceNo}}
                            <ng-container *ngIf="historyBillTop.billType == 1">
                                <span class="ic-wrapper" title="Estimated bill">
                                    <svg class="ic">
                                        <use xlink:href="#ic-concerning-bill" href="#ic-concerning-bill"></use>
                                    </svg>
                                </span>
                            </ng-container>
                            <ng-container *ngIf="historyBillTop.billType == 2">
                                <span class="ic-wrapper" title="Independent bill">
                                    <svg class="ic">
                                        <use xlink:href="#ic-independent-bill" href="#ic-independent-bill"></use>
                                    </svg>
                                </span>
                            </ng-container>
                            <ng-container *ngIf="historyBillTop.billType == 3">
                                <span class="ic-wrapper" title="Credit invoice">
                                    <svg class="ic">
                                        <use xlink:href="#ic-credit-bill" href="#ic-credit-bill"></use>
                                    </svg>
                                </span>
                            </ng-container>
                        </td>
                        <td data-label="Bill period">{{historyBillTop.billFromDate | date:'dd/MM/yyyy'}} - {{historyBillTop.billToDate | date:'dd/MM/yyyy'}}</td>
                        <td data-label="Bill date">{{historyBillTop.datePosted | date:'dd/MM/yyyy'}}</td>
                        <td data-label="Ex. VAT">{{historyBillTop.amountExVat | currency:'GBP'}}</td>
                        <td data-label="VAT">{{historyBillTop.totalVat | currency:'GBP'}}</td>
                        <td data-label="Total">{{historyBillTop.totalAmount | currency:'GBP'}}</td>
                        <td data-label="">                        
                            <button class="text-link focus-element" (click)="getBillsDocument(historyBillTop.invoiceNo)">
                                <span class="focus--content">
                                    Download
                                </span>
                            </button>
                        </td>
                        <td class="text-right" data-label="">
                            <button class="text-link focus-element" collapsible [collapsibleSection]="collapsibleSection" [collapsibleTitle]="collapsibleTitle" [isCollapsed]="historyBillTop.isCollapsed === true ? true : false" (click)="toggleBillItemExpand(i)">
                                <span class="focus--content">
                                    <svg class="m-ic m-ic--sm m-ic--arrow m-ic--arrow-o h-valign--middle" [ngClass]="historyBillTop.isCollapsed === false ? 'm-ic--arrow-open' : 'm-ic--arrow'">
                                        <use xlink:href="#ic-arrow" href="#ic-arrow"></use>
                                    </svg>
                                </span>
                            </button>
                        </td>
                    </tr>
                    <tr class="transparent">
                        <td colspan="7" class="std-table__nested-wrapper">
                            <div class="collapsible" #collapsibleSection>
                                <table class="std-table std-table__nested">
                                    <thead>
                                    <th>Charge name</th>
                                    <th>Period of charge</th>
                                    <th>Quantity</th>
                                    <th>Unit</th>
                                    <th>Unit cost</th>
                                    <th>Ex. VAT</th>
                                    <th>VAT</th>
                                    <tbody>
                                        <tr *ngFor="let historyBill of historyBills[i].details">
                                            <td data-label="Charge name">{{historyBill.chargeName}}</td>
                                            <td data-label="Period of charge">{{historyBill.chargeFromDate | date:'dd/MM/yyyy'}} - {{historyBill.chargeToDate | date:'dd/MM/yyyy'}} </td>
                                            <td data-label="Quantity">{{historyBill.quantity}}</td>
                                            <td data-label="Unit">{{historyBill.unit}}</td>
                                            <td data-label="Unit cost">{{historyBill.unitCost | currency:'GBP':'symbol':'1.5-5'}}</td>
                                            <td data-label="Ex. VAT">{{historyBill.amountExVat | currency:'GBP'}}</td>
                                            <td data-label="VAT">{{historyBill.vatrate | number:'1.2-4'}}%</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
        <app-pagination *ngIf="!isSearching && historyBills.length > 0" [page]="page" [pages]="historyPaymentsTotalPages" (pageChange)="pageSelected($event)"></app-pagination>
    </div>
</div>
